import { render, staticRenderFns } from "./boton-cerrar-modal.vue?vue&type=template&id=1fa7788c&scoped=true&"
import script from "./boton-cerrar-modal.vue?vue&type=script&lang=js&"
export * from "./boton-cerrar-modal.vue?vue&type=script&lang=js&"
import style0 from "./boton-cerrar-modal.vue?vue&type=style&index=0&id=1fa7788c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa7788c",
  null
  
)

export default component.exports